import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { PublicNavbar } from '@/components/navbar/PublicNavbar';
import { PublicFooter } from '@/components/landing/PublicFooter';
import { PageTransition } from '@/components/PageTransition';

export function PublicLayout() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#050510' }}>
      <PublicNavbar />
      <Box sx={{ pt: '72px' }}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Box>
      <PublicFooter />
    </Box>
  );
}
